import React, { ReactNode } from 'react';
import './Field.less';

type Props = {
  name: string;
  value: ReactNode;
};

const Field: React.FC<Props> = ({ name, value }) => {
  return (
    <>
      <div className="FieldComponent-name">{name}</div>
      <div className="FieldComponent-value">{value}</div>
    </>
  );
};

export default Field;
